<div
        class="card text-center"
        [ngClass]="
            {
                'cursor-pointer': cursor,
                'in-progress-card-prixtel' : (status === 'wait_form' && brand == 'prixtel'),
                'in-progress-card-coriolis' : (status === 'wait_form' && brand == 'coriolis'),
                'disabled-card': status == 'disabled',
                'active-card': status != 'disabled',
                'card-long-text': longText,
                'card-sfr' : brand == 'lacarte' && extra
            }
        ">
    @if (icon) {
        <div class="card-block">
            <img src="../../../../../assets/images/{{ icon }}">
        </div>
    }
    @if (!icon) {
        <div class="h-25"></div>
    }
    <div class="row-100 text-center p-1">
        <h3 class="procedure-card_title">{{ text }}</h3>
        @if (value) {
            <p class="procedure-card_value ">{{ value }}</p>
        }
        @if (priceDetails) {
            <p class="blue-color pt-3 price-details">{{ priceDetails.price }}@if (priceDetails.perMonth) {
                <span>/mois</span>
            }</p>
        }
    </div>
    @if (extra) {
        <div class="card-fixed-date">
            {{ extra }}
        </div>
    }
</div>
